import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _0e4b220a = () => interopDefault(import('../src/pages/cookie-policy.vue' /* webpackChunkName: "pages/cookie-policy" */))
const _29bd595a = () => interopDefault(import('../src/pages/maintenance.vue' /* webpackChunkName: "pages/maintenance" */))
const _1f8840b8 = () => interopDefault(import('../src/pages/manage-booking/index.vue' /* webpackChunkName: "pages/manage-booking/index" */))
const _0c5f1207 = () => interopDefault(import('../src/pages/privacy-policy.vue' /* webpackChunkName: "pages/privacy-policy" */))
const _300c8bf8 = () => interopDefault(import('../src/pages/receipt.vue' /* webpackChunkName: "pages/receipt" */))
const _feb487d0 = () => interopDefault(import('../src/pages/search.vue' /* webpackChunkName: "pages/search" */))
const _663d85b2 = () => interopDefault(import('../src/pages/search-booking/index.vue' /* webpackChunkName: "pages/search-booking/index" */))
const _3500a7e4 = () => interopDefault(import('../src/pages/terms-and-conditions.vue' /* webpackChunkName: "pages/terms-and-conditions" */))
const _0dd25536 = () => interopDefault(import('../src/pages/travel-extras.vue' /* webpackChunkName: "pages/travel-extras" */))
const _1d254560 = () => interopDefault(import('../src/pages/unsupported-browser.vue' /* webpackChunkName: "pages/unsupported-browser" */))
const _0355929b = () => interopDefault(import('../src/pages/manage-booking/cancel/index.vue' /* webpackChunkName: "pages/manage-booking/cancel/index" */))
const _358c2858 = () => interopDefault(import('../src/pages/manage-booking/modify.vue' /* webpackChunkName: "pages/manage-booking/modify" */))
const _38d99f8a = () => interopDefault(import('../src/pages/manage-booking/receipt.vue' /* webpackChunkName: "pages/manage-booking/receipt" */))
const _ac6ec648 = () => interopDefault(import('../src/pages/manage-booking/update-details.vue' /* webpackChunkName: "pages/manage-booking/update-details" */))
const _bd01c912 = () => interopDefault(import('../src/pages/select-extras/product/index.vue' /* webpackChunkName: "pages/select-extras/product/index" */))
const _275b1e7e = () => interopDefault(import('../src/pages/manage-booking/cancel/receipt.vue' /* webpackChunkName: "pages/manage-booking/cancel/receipt" */))
const _7a7b0f92 = () => interopDefault(import('../src/pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/cookie-policy",
    component: _0e4b220a,
    name: "cookie-policy"
  }, {
    path: "/maintenance",
    component: _29bd595a,
    name: "maintenance"
  }, {
    path: "/manage-booking",
    component: _1f8840b8,
    name: "manage-booking"
  }, {
    path: "/privacy-policy",
    component: _0c5f1207,
    name: "privacy-policy"
  }, {
    path: "/receipt",
    component: _300c8bf8,
    name: "receipt"
  }, {
    path: "/search",
    component: _feb487d0,
    name: "search"
  }, {
    path: "/search-booking",
    component: _663d85b2,
    name: "search-booking"
  }, {
    path: "/terms-and-conditions",
    component: _3500a7e4,
    name: "terms-and-conditions"
  }, {
    path: "/travel-extras",
    component: _0dd25536,
    name: "travel-extras"
  }, {
    path: "/unsupported-browser",
    component: _1d254560,
    name: "unsupported-browser"
  }, {
    path: "/manage-booking/cancel",
    component: _0355929b,
    name: "manage-booking-cancel"
  }, {
    path: "/manage-booking/modify",
    component: _358c2858,
    name: "manage-booking-modify"
  }, {
    path: "/manage-booking/receipt",
    component: _38d99f8a,
    name: "manage-booking-receipt"
  }, {
    path: "/manage-booking/update-details",
    component: _ac6ec648,
    name: "manage-booking-update-details"
  }, {
    path: "/select-extras/product",
    component: _bd01c912,
    name: "select-extras-product"
  }, {
    path: "/manage-booking/cancel/receipt",
    component: _275b1e7e,
    name: "manage-booking-cancel-receipt"
  }, {
    path: "/",
    component: _7a7b0f92,
    name: "index"
  }, {
    path: "/dedicated",
    component: _7a7b0f92,
    meta: {"auth0Flow":"dedicated"},
    name: "dedicated-wl-index"
  }, {
    path: "/dedicated/search",
    component: _feb487d0,
    meta: {"auth0Flow":"dedicated"},
    name: "dedicated-wl-search"
  }, {
    path: "/dedicated/select-extras/product",
    component: _bd01c912,
    meta: {"auth0Flow":"dedicated"},
    name: "dedicated-wl-select-extras"
  }, {
    path: "/dedicated/travel-extras",
    component: _0dd25536,
    meta: {"auth0Flow":"dedicated"},
    name: "dedicated-wl-travel-extras"
  }, {
    path: "/dedicated/manage-booking/modify",
    component: _358c2858,
    meta: {"auth0Flow":"dedicated"},
    name: "dedicated-wl-modify"
  }, {
    path: "/dedicated/receipt",
    component: _300c8bf8,
    meta: {"auth0Flow":"dedicated"},
    name: "dedicated-wl-receipt"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
